import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import { firstValueFrom} from "rxjs";
import {loadCapacitorApp} from "../../utils/capacitor-app.helper";
import {assert} from "typia";
import {isNative, platform as runtimePlatform} from "../../utils";
import {Browser} from "@capacitor/browser";
import {AppLauncher} from "@capacitor/app-launcher";
import {MandatoryUpdateComponent} from "./mandatory-update/mandatory-update.component";
import {DialogService} from "primeng/dynamicdialog";
import {environment} from "../../../../environments/environment";
import {StatusBar, Style} from "@capacitor/status-bar";

if (isNative) {
  StatusBar.setStyle({ style: Style.Dark });
}

@Injectable({
  providedIn: 'root'
})
export class NativeAppService {
  private readonly httpClient = inject(HttpClient);
  private readonly dialogService = inject(DialogService);

  public async retrieveData() {
    try {
      if (!isNative) {
        return
      }

      const App = await loadCapacitorApp();
      if (!App) {
        return;
      }
      const info = await App.getInfo();

      const result = await firstValueFrom(this.httpClient.get(`${environment.apiUrl}/api/public/app/version/is-supported`, {
        params: {
          version: info.version
        }
      }));

      const parsedResult = assert<{ success: boolean }>(result);
      if (!parsedResult.success) {
        this.showUpdateDialog();
        await new Promise(() => {})
      }
    } catch (e: unknown) {
      console.error('Failed to retrieve app data', e);
    }
  }

  public showUpdateDialog() {
    return this.dialogService.open(
      MandatoryUpdateComponent,
      {
        header: 'Update Required',
        closable: false,
        modal: true,
        focusOnShow: false,
        width: 'calc(min(100vw - 10px, 500px))',
      }
    )
  }

  async openStorePage() {
    const platform = runtimePlatform;
    let url: string;

    if (platform === 'ios') {
      url = 'itms-apps://itunes.apple.com/app/6748840051';
    } else if (platform === 'android') {
      url = 'market://details?id=io.myhomey.app';                     // replace with your package
    } else {
      // fallback for web/Electron
      url = 'https://apps.apple.com/app/6748840051';
    }

    try {
      await AppLauncher.openUrl({ url });
    } catch {
      // For non-http(s) schemes, Browser.open only works with http(s), so we catch and redirect web users.
      await Browser.open({ url });
    }
  }
}
